import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import TopNavbar from "./TopNavbar";
import SideNav from "./SideNav";
import { useDispatch } from "react-redux";
import { usersThunks } from "../app/store";


export default function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(usersThunks.list({ limit: 9999, offset: 0 }));
  }, [dispatch]);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <TopNavbar
        sidebarOpen={sidebarOpen}
        onToggleSidebar={() => setSidebarOpen((v) => !v)}
      />

      <div className="flex">
        <SideNav open={sidebarOpen} />

        <main className={`flex-1 p-4 ${sidebarOpen ? "md:ml-64" : "md:ml-16"}`}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
